import { render, staticRenderFns } from "./ActivityTemplate.vue?vue&type=template&id=ab96d230"
import script from "./ActivityTemplate.vue?vue&type=script&lang=js"
export * from "./ActivityTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports